import { render, staticRenderFns } from "./CartUpdate.vue?vue&type=template&id=3b45c8d4&"
import script from "./CartUpdate.vue?vue&type=script&lang=ts&"
export * from "./CartUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports